<template>
    <div>
        <div class="row">
            <div class="col-lg-3">
                <div class="form-group mb-4">
                    <label for="collection_start">
                        <strong>
                            Collection Dates
                        </strong>
                    </label>
                    <div class="input-daterange input-group">
                        <input v-model="filters.collectionDateFrom"
                               class="input-sm form-control js-date-picker "
                               name="collection_start"
                               value=""
                               type="text"
                        >
                        <span class="input-group-addon">to</span>
                        <input v-model="filters.collectionDateTo"
                               class="input-sm form-control js-date-picker"
                               name="collection_end"
                               value=""
                               type="text"
                        >
                    </div>
                </div>
                <div class="form-group mb-4">
                    <label>
                        <strong>
                            Delivery Dates
                        </strong>
                    </label>
                    <div class="input-daterange input-group">
                        <input v-model="filters.deliveryDateFrom"
                               class="input-sm form-control js-date-picker"
                               name="delivery_start"
                               value=""
                               type="text"
                        >
                        <span class="input-group-addon">to</span>
                        <input v-model="filters.deliveryDateTo"
                               class="input-sm form-control js-date-picker"
                               name="delivery_end"
                               value=""
                               type="text"
                        >
                    </div>
                </div>
            </div>
            <div class="col-lg-3" v-if="!hide.includes('customer')">
                <CustomerSelect
                    v-model="filters.selectedCustomer"
                    :errors="errors ? errors : []"
                />
            </div>
            <div class="col-lg-3" v-if="!hide.includes('drivers')">
                <!-- this component doesn't clear properly -->
                <DriverSelect
                    :errors="[]"
                    @update-driver="updateSelectedDriver"
                />
            </div>
            <div class="col-lg-6">
                <label>
                    <strong>
                        Status
                    </strong>
                </label>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-signed-off" title="Admin satisfied with Job, ready for Invoice">
                                <input v-model="filters.status" class="me-1" id="checkbox-signed-off" type="checkbox" name="status[]" value="signed-off" />
                                Signed Off
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-ready-to-invoice" title="All Movements completed, Job Ready to Invoice">
                                <input v-model="filters.status" class="me-1" id="checkbox-ready-to-invoice" type="checkbox" name="status[]" value="ready-to-invoice" />
                                Ready to Invoice
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-completed" title="All Movements completed, Job finished">
                                <input v-model="filters.status" class="me-1" id="checkbox-completed" type="checkbox" name="status[]" value="completed" />
                                Completed
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-in-progress" title="Movements started, not all Movements finished">
                                <input v-model="filters.status" class="me-1" id="checkbox-in-progress" type="checkbox" name="status[]" value="in-progress" />
                                In Progress
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-assigned" title="All Movements assigned, none started">
                                <input v-model="filters.status" class="me-1" id="checkbox-assigned" type="checkbox" name="status[]" value="assigned" />
                                All Assigned
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-accepted" title="Job accepted, ready for Movement assignment">
                                <input v-model="filters.status" class="me-1" id="checkbox-accepted" type="checkbox" name="status[]" value="accepted" />
                                Accepted
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-closed" title="Job invoiced to Customer">
                                <input v-model="filters.status" class="me-1" id="checkbox-closed" type="checkbox" name="status[]" value="closed" />
                                Closed
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-aborted" title="Driver travelled to collect Vehicle, Vehicle not able to be moved">
                                <input v-model="filters.status" class="me-1" id="checkbox-aborted" type="checkbox" name="status[]" value="aborted" />
                                Aborted
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-part-assigned" title="Some Movements assigned, some outstanding">
                                <input v-model="filters.status" class="me-1" id="checkbox-part-assigned" type="checkbox" name="status[]" value="part-assigned" />
                                Part Assigned
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-pending-acceptance" title="Job created by Customer, not able to be assigned">
                                <input v-model="filters.status" class="me-1" id="checkbox-pending-acceptance" type="checkbox" name="status[]" value="pending-acceptance"/>
                                Pending Acceptance
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-pending-review" title="Job awaiting approval from Customer">
                                <input v-model="filters.status" class="me-1" id="checkbox-pending-review" type="checkbox" name="status[]" value="pending-review"/>
                                Pending Review
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <table ref="jobsTable" class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
                <thead>
                    <tr>
                        <th v-if="!hide.includes('select')" class="text-center">
                            <input type="checkbox" id="checkAll" />
                        </th>
                        <th v-if="!hide.includes('reference')">Job Ref.</th>
                        <th v-if="!hide.includes('status')">Status</th>
                        <th v-if="!hide.includes('contract')">Contract</th>
                        <th v-if="!hide.includes('customer')">Customer</th>
                        <th v-if="!hide.includes('drivers')">Drivers</th>
                        <th v-if="!hide.includes('clientRef')">Purchase Order (Client Ref.)</th>
                        <th v-if="!hide.includes('collectionDate')">Collection Date</th>
                        <th v-if="!hide.includes('deliveryDate')">Delivery Date</th>
                        <th v-if="!hide.includes('journey')">Journey</th>
                        <th v-if="!hide.includes('vehicle')">Vehicle</th>
                        <th v-if="!hide.includes('actions')">Actions</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';
import { buildColumns } from "@/helpers/build-columns";
import CustomerSelect from '@/components/movements/components/CustomerSelect.vue';
import DriverSelect from '@/components/movements/components/DriverSelect.vue';
import flatpickr from 'flatpickr';

const props = defineProps({
    ajaxUrl: {
        type: String,
        required: true,
    },
    filter: {
        type: String,
        required: false
    },
    hide: {
        type: Array,
        default: () => [],
        required: false
    },
    orderBy: {
        type: Array,
        default: [[6, 'desc']]
    },
    old: {
        type: String,
        required: false
    },
    errors: {
        type: Array,
        default: () => [],
        required: false
    },
});

const columnDefinitions = reactive({
    select: {
        data: 'id',
        orderable: false,
        searchable: false,
        width: '70px',
        render: function (data, type, row) {
            return row.computed_select;
        },
    },
    reference: {
        data: 'id',
        render: function (data, type, row) {
            return row.computed_reference;
        }
    },
    status: {
        data: 'status',
        searchable: false,
    },
    contract: {
        data: 'contract.name',
        searchable: false,
        render: function (data, type, row) {
            return row.computed_contract;
        }
    },
    customer: {
        name: 'customer.name',
        render: function (data, type, row) {
            return row.computed_customer;
        }
    },
    drivers: {
        searchable: false,
        orderable: false,
        render: function (data, type, row) {
            return row.computed_drivers;
        }
    },
    clientRef: {
        data: 'client_ref',
        searchable: false,
    },
    collectionDate: {
        data: 'collection_date',
        width: '200px',
        render: function (data, type, row) {
            return row.computed_collection_date;
        }
    },
    deliveryDate: {
        name: 'delivery_date',
        width: '200px',
        render: function (data, type, row) {
            return row.computed_delivery_date;
        }
    },
    journey: {
        searchable: false,
        orderable: false,
        width: '200px',
        render: function (data, type, row) {
            return row.collection_locale + '<br> to ' + row.delivery_locale;
        },
    },
    vehicle: {
        searchable: false,
        orderable: false,
        render: function (data, type, row) {
            return row.computed_vehicle;
        }
    },
    actions: {
        name: 'actions',
        data: 'actions',
        searchable: false,
        orderable: false,
        width: '200px',
    }
});

const filters = reactive({
    invoiceDateFrom: null,
    invoiceDateTo: null,
    collectionDateFrom: null,
    collectionDateTo: null,
    deliveryDateFrom: null,
    deliveryDateTo: null,
    status: [
        'signed-off',
        'completed',
        'in-progress',
        'assigned',
        'accepted',
        'closed',
        'aborted',
        'part-assigned',
        'pending-acceptance',
        'pending-review',
        'ready-to-invoice',
    ],
    selectedCustomer: null,
    selectedDriver: null,
});

const jobsTable = ref(null);
const updateSelectedDriver = (value) => {
    filters.selectedDriver = value ?? null;
};

onMounted(() => {

    if (props.filter) {
        filters.status = [props.filter];
    }

    const table = window.jQuery(jobsTable.value).on('preXhr.dt', (e, settings, data) => {
        data.filters = filters;
    }).DataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ajax: {
            url: props.ajaxUrl,
        },
        order: props.orderBy,
        columns: buildColumns(columnDefinitions, props.hide),
    });

    // Initialize flatpickr for delivery date inputs
    flatpickr('.js-date-picker', {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d',
    });

    // watch api to use table without saving it to data
    watch(
        filters,
        () => table.ajax.reload(null, false),
        {
            deep: true
        }
    );

    table.on('draw', function() {
        window.jQuery('#checkAll').on( 'click', function() {
            window.jQuery('.bulk-update-checkbox').each((_, el) => {
                window.jQuery(el).click();
                el.checked = this.checked;
            });
        });
    });
});
</script>
